var _clipPath, _clipPath2, _path, _path2, _use, _use2, _use3, _use4, _use5, _g, _path3, _path4, _path5, _path6, _path7, _path8, _use6, _use7, _use8, _use9, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _use10, _path16, _path17, _path18, _path19, _path20;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    height: 300,
    width: 600,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0v75h350v75h-50zm300 0H150v200H0v-50z"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h300v150H0z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h600v300H0z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M600 260.881c-6.723 4.045-12.499 13.498-30.36 13.498-35.711 0-44.641-19.902-71.427-19.902-17.856 0-26.785 19.902-44.641 19.902-35.715 0-44.643-19.902-71.429-19.902-17.857 0-26.786 19.902-44.643 19.902-35.714 0-44.643-19.902-71.428-19.902-17.858 0-26.786 19.902-44.643 19.902-35.714 0-44.643-19.902-71.429-19.902-17.858 0-26.786 19.902-44.643 19.902-35.714 0-44.643-19.902-71.428-19.902-17.858 0-23.215 14.182-33.929 14.182v25.621c10.714 0 16.071-14.181 33.929-14.181 26.785 0 35.714 19.901 71.428 19.901 17.857 0 26.785-19.901 44.643-19.901 26.785 0 35.715 19.901 71.429 19.901 17.857 0 26.785-19.901 44.643-19.901 26.785 0 35.714 19.901 71.428 19.901 17.857 0 26.786-19.901 44.643-19.901 26.786 0 35.714 19.901 71.429 19.901 17.856 0 26.785-19.901 44.641-19.901 26.786 0 35.716 19.901 71.427 19.901 17.861 0 23.637-5.64 30.36-9.684z",
    fill: "#012169"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    transform: "translate(0 -49.753)",
    xlinkHref: "#a"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    transform: "translate(0 -99.507)",
    xlinkHref: "#a"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    transform: "translate(0 -149.26)",
    xlinkHref: "#a"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    transform: "translate(0 -199.014)",
    xlinkHref: "#a"
  })), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    transform: "translate(0 -248.768)",
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h290v152H0z",
    fill: "#fff",
    style: {
      strokeWidth: 0.983192
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h300v150H0z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 300 150m0-150L0 150",
    stroke: "#fff",
    strokeWidth: 30
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#c)",
    d: "m0 0 300 150m0-150L0 150",
    stroke: "#c8102e",
    strokeWidth: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 0v200M0 75h350",
    stroke: "#fff",
    strokeWidth: 50
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 0v200M0 75h350",
    stroke: "#c8102e",
    strokeWidth: 30
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m446.523 79.222-2.069 204.161c-.28 11.585 10.345 11.63 10.345 0l-2.069-204.16z",
    fill: "#a24300",
    stroke: "#fff",
    strokeWidth: 6.935,
    style: {
      stroke: "#000",
      strokeWidth: 0.75,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.43857 0 0 .37683 122.2 25.058)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-.31451 .10485 -.1383 -.30323 1046.472 373.319)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d",
    fill: "none",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m496.063 549.213 17.717 70.866 35.433-53.15-17.717 88.583 35.433-35.433-35.433 88.582 35.433-35.433-35.433 88.583 35.433-35.433-35.433 106.299 35.433-35.433-35.433 106.299 35.433-35.433-35.433 106.299-17.716 53.151-17.717 17.72-17.717-17.72-17.716-53.151-35.433-106.299 35.433 35.433-35.433-106.299 35.433 35.433-35.433-106.299 35.433 35.433-35.433-88.583 35.433 35.433-35.433-88.582 35.433 35.433-17.717-88.583 35.433 53.15z",
    fill: "#006d00",
    stroke: "#fff",
    strokeWidth: 8.25,
    transform: "translate(177.166 -224.052)",
    style: {
      stroke: "#000",
      strokeOpacity: 1,
      strokeWidth: 4.45265468,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M496.063 549.213v496.067m-70.866-177.17 70.866 106.299 70.866-106.299",
    transform: "translate(177.166 -224.052)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m425.197 797.244 70.866 106.299 70.866-106.299",
    transform: "translate(177.166 -224.052)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m425.197 726.378 70.866 106.299 70.866-106.299",
    transform: "translate(177.166 -224.052)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m425.197 673.228 70.866 88.583 70.866-88.583",
    transform: "translate(177.166 -224.052)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m425.197 620.079 70.866 88.582 70.866-88.582",
    transform: "translate(177.166 -224.052)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m442.913 566.929 53.15 106.299 53.15-106.299",
    transform: "translate(177.166 -224.052)"
  })))), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    transform: "matrix(.23652 -.28186 .29496 .22762 354.567 204.654)",
    xlinkHref: "#d"
  })), _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    transform: "matrix(.15164 .33524 -.3329 .1673 907.539 -153.47)",
    xlinkHref: "#d"
  })), _use8 || (_use8 = /*#__PURE__*/React.createElement("use", {
    transform: "matrix(-.20952 .30246 -.3147 -.19945 1141.363 167.58)",
    xlinkHref: "#d"
  })), _use9 || (_use9 = /*#__PURE__*/React.createElement("use", {
    transform: "matrix(-.20772 -.25838 .23618 -.23515 689.986 567.277)",
    xlinkHref: "#d"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-.36218 -.09947 -.2098 .31773 1222.415 -24.23)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e",
    fill: "none",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m460.63 549.213 28.643 70.866 42.223-53.15-10.184 88.583 27.9-35.433-17.716 88.582 25.249-35.433-25.249 88.583 35.433-35.433-35.433 106.299 35.433-35.433-35.433 106.299 35.433-35.433-35.433 106.299-17.716 53.151-17.717 17.72-17.717-17.72-17.716-53.151-35.433-106.299 35.433 35.433-35.433-106.299 35.433 35.433-35.433-106.299 35.433 35.433-45.617-88.583 45.617 35.433-53.15-88.582 42.966 35.433-25.25-88.583 35.433 53.15z",
    fill: "#006d00",
    stroke: "#fff",
    strokeWidth: 8.25,
    transform: "translate(283.465 -124.016)",
    style: {
      strokeWidth: 3.33574655,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      stroke: "#000",
      strokeOpacity: 1
    }
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m467.208 584.646 28.855 124.016v336.618",
    transform: "translate(283.465 -124.016)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m436.23 885.827 59.833 88.582 60.682-88.582",
    transform: "translate(283.465 -124.016)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m434.533 814.961 61.53 88.582 60.682-88.582",
    transform: "translate(283.465 -124.016)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m435.381 744.095 60.682 88.582 59.833-88.582",
    transform: "translate(283.465 -124.016)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m432.835 690.945 63.228 70.866 53.149-70.866",
    transform: "translate(283.465 -124.016)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m425.197 637.796 70.866 70.865 45.406-70.865",
    transform: "translate(283.465 -124.016)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m436.124 593.238 53.15 86.886 35.327-95.478",
    transform: "translate(283.465 -124.016)"
  })))), _use10 || (_use10 = /*#__PURE__*/React.createElement("use", {
    transform: "matrix(.36088 .10411 .01321 .38053 452.761 -239.266)",
    xlinkHref: "#e"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m354.331 531.496 88.583 88.583 17.716-53.149v88.582l35.433-35.433-17.716 88.583 35.432-35.434-17.716 88.584 35.433-35.433-17.716 106.299 35.433-35.433-35.433 106.299 35.433-35.433-17.717 106.298-17.716 53.151-17.717 17.72-17.717-17.72-17.716-53.151-53.15-82.294 35.434 11.429-35.433-106.299 35.433 35.433-53.15-106.299 35.433 35.433-53.15-88.584 53.15 35.434-70.866-88.583 53.149 35.433-70.866-70.866 70.866 35.433z",
    fill: "#006d00",
    stroke: "#fff",
    strokeWidth: 8.25,
    style: {
      strokeWidth: 3.52269083,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      stroke: "#000",
      strokeOpacity: 1
    },
    transform: "matrix(.04613 -.36474 .32602 .0648 386.005 315.21)"
  }), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m378.962 560.015 63.952 95.497 17.716 53.15 8.859 45.205 8.858 78.811 9.315 70.866 8.401 141.736",
    transform: "matrix(.04613 -.36474 .32602 .0648 386.005 315.21)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m425.197 903.544 63.665 70.866 50.749-88.583",
    transform: "matrix(.04613 -.36474 .32602 .0648 386.005 315.21)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m417.082 814.961 70.579 88.583 50.75-88.583",
    transform: "matrix(.04613 -.36474 .32602 .0648 386.005 315.21)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m407.48 752.443 70.867 80.235 45.948-88.583M372.047 637.796l88.583 70.866 25.831-70.866",
    transform: "matrix(.04613 -.36474 .32602 .0648 386.005 315.21)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m360.618 602.363 82.296 53.149 10.515-53.149m-63.665 88.582 81.095 70.866 33.946-70.866",
    transform: "matrix(.04613 -.36474 .32602 .0648 386.005 315.21)"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M451.749 194.518h28.445s1.872-4.25 2.083-6.132c.253-2.26.245-2.986-.277-5.07-.541-2.157-1.327-3.64-2.679-5.082-1.275-1.36-3.071-2.202-4.91-2.661-1.642-.41-3.496-.585-4.935-.266-2.734.607-4.51 1.569-7.482 2.579-2.144.729-3.782.978-5.95 1.11-1.326.082-2.858-.274-4.295-.604zm-4.24 0h-28.446s-1.87-4.25-2.082-6.132c-.253-2.26-.245-2.986.278-5.07.54-2.157 1.326-3.64 2.678-5.082 1.275-1.36 3.072-2.202 4.911-2.661 1.64-.41 3.495-.585 4.934-.266 2.734.607 4.51 1.569 7.482 2.579 2.144.729 3.782.978 5.95 1.11 1.326.082 2.858-.274 4.295-.604z",
    style: {
      color: "#000",
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: "medium",
      lineHeight: "normal",
      fontFamily: "'Bitstream Vera Sans'",
      InkscapeFontSpecification: "'Bitstream Vera Sans'",
      textIndent: 0,
      textAlign: "start",
      textDecoration: "none",
      textDecorationLine: "none",
      letterSpacing: "normal",
      wordSpacing: "normal",
      textTransform: "none",
      writingMode: "lr-tb",
      direction: "ltr",
      textAnchor: "start",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 0.995,
      fill: "#fff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.300754,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1,
      marker: "none",
      enableBackground: "accumulate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1078.843 808.643c-9.002.106-18.004.283-26.935.85-6.593.497-14.106 1.064-20.521 1.985l-1.63.284c-4.04.78-4.608 5.6-2.481 8.222 4.324 5.423 29.948 9.64 60.215 9.64 30.231 0 55.855-4.217 60.179-9.64 2.126-2.623 1.56-7.443-2.481-8.222l-1.63-.284c-6.38-.921-13.929-1.488-20.52-1.985-8.932-.567-17.934-.744-26.936-.85h-8.612z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.44777 0 0 .48232 -37.317 -169.71)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1093.48 813.817a68.692 68.692 0 0 1-6.238-1.311 78.627 78.627 0 0 1-4.855-1.489c.46.745 1.134 1.489 2.764 2.056-1.31-.035-3.047.46-3.685.744.638.248 2.445.745 3.756.71-1.594.566-2.197 1.31-2.551 2.055a59.605 59.605 0 0 1 4.43-1.383 68.882 68.882 0 0 1 6.38-1.382zm-23.533.107a59.52 59.52 0 0 1-6.238-1.135 53.966 53.966 0 0 1-4.89-1.346c.425.744 1.134 1.453 2.8 1.984-1.347 0-3.048.567-3.651.851.638.248 2.445.673 3.757.603-1.56.602-2.162 1.382-2.517 2.126 1.383-.532 2.836-1.063 4.395-1.524 1.985-.602 4.076-1.099 6.344-1.56zm-23.356 1.134a66.684 66.684 0 0 1-6.344-.71c-1.736-.283-3.402-.602-4.962-.991.497.708 1.241 1.382 2.942 1.772-1.311.106-2.977.78-3.58 1.098.674.177 2.482.496 3.793.355-1.524.709-2.056 1.524-2.34 2.303 1.347-.638 2.765-1.276 4.29-1.843a53.146 53.146 0 0 1 6.201-1.984zm70.422-.78c-2.233.319-4.324.673-6.273 1.134a44.33 44.33 0 0 0-4.89 1.382c.46-.744 1.133-1.488 2.799-1.984-1.311-.036-3.048-.567-3.65-.851.637-.248 2.445-.673 3.756-.638-1.56-.602-2.162-1.347-2.48-2.126 1.382.567 2.835 1.063 4.394 1.559 1.95.567 4.04 1.099 6.344 1.524zm23.285 1.949c-2.233.142-4.324.355-6.308.674a65.386 65.386 0 0 0-4.998 1.027c.532-.708 1.276-1.382 2.977-1.772-1.346-.106-3.012-.78-3.615-1.098.674-.213 2.481-.532 3.828-.355-1.524-.709-2.091-1.524-2.375-2.303a70.806 70.806 0 0 0 4.289 1.843 71.184 71.184 0 0 0 6.202 1.984z",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.44777 0 0 .48232 -37.317 -169.71)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1087.49 818.92c-36.079 0-57.946 2.092-56.138 3.687 12.652 5.28 37.567 6.982 56.139 7.017 18.535-.035 43.45-1.737 56.103-7.017 1.808-1.595-20.06-3.686-56.103-3.686z",
    style: {
      fill: "#ccc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.44777 0 0 .48232 -37.317 -169.71)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1143.523 822.713c.32-.85-1.098-1.099-2.587-1.276-5.777-.744-12.192-1.24-17.898-1.666-8.931-.567-17.933-.744-26.935-.85h-17.26c-9.002.106-18.004.283-26.935.85-5.707.426-12.121.922-17.898 1.666-1.489.177-2.907.425-2.588 1.276",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.616,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(.44777 0 0 .48232 -37.317 -169.71)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1078.843 808.643c-9.002.106-18.004.283-26.935.85-6.593.497-14.106 1.064-20.521 1.985l-1.63.284c-4.04.78-4.608 5.6-2.481 8.222 4.324 5.423 29.948 9.64 60.215 9.64 30.231 0 55.855-4.217 60.179-9.64 2.126-2.623 1.56-7.443-2.481-8.222l-1.63-.284c-6.38-.921-13.929-1.488-20.52-1.985-8.932-.567-17.934-.744-26.936-.85h-8.612z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.616,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(.44777 0 0 .48232 -37.317 -169.71)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 1.17646,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      strokeWidth: 2.41697,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1219.614 702.297 17.558-48.6 7.092-20.121 17.575-10.353 17.8-38.344 8.386-10.028 1.294-35.329s-12.298-25.06-31.33-34.06c-27.225-12.874-64.18-11.103-64.18-11.103s-8.536-21.396-24.192-29.722c-15.657-8.327-33.042-10.334-51.29-10.334-18.246 0-50.994 15.463-68.703 20.009-9.207 2.363-29.998 10.333-29.998 10.333s-20.792-7.97-29.999-10.333c-17.709-4.546-50.457-20.009-68.704-20.009-18.247 0-35.064 1.705-51.289 10.334-15.088 8.024-35.803 29.722-35.803 29.722s-23.717-3.051-40.378 6.45c-20.783 11.851-35.428 36.778-35.428 36.778l1.435 38.6 3.272 14.756 13.43 14.63 17.507 29.548 12.543 29.142 13.425 38.034z",
    style: {
      fill: "#c8102e",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "matrix(.11116 0 0 .12634 335.833 127.758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1219.614 702.297 17.558-48.6 7.092-20.121 17.575-10.353 17.8-38.344 8.386-10.028 1.294-35.329s-12.298-25.06-31.33-34.06c-27.225-12.874-64.18-11.103-64.18-11.103s-8.536-21.396-24.192-29.722c-15.657-8.327-33.042-10.334-51.29-10.334-18.246 0-50.994 15.463-68.703 20.009-9.207 2.363-29.998 10.333-29.998 10.333s-20.792-7.97-29.999-10.333c-17.709-4.546-50.457-20.009-68.704-20.009-18.247 0-35.064 1.705-51.289 10.334-15.088 8.024-35.803 29.722-35.803 29.722s-23.717-3.051-40.378 6.45c-20.783 11.851-35.428 36.778-35.428 36.778l1.435 38.6 3.272 14.756 13.43 14.63 17.507 29.548 12.543 29.142 13.425 38.034z",
    style: {
      display: "inline",
      fill: "none",
      stroke: "#000",
      strokeWidth: 2.41697,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(.11116 0 0 .12634 335.833 127.758)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 1.17646,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 1.17646,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 1.17646,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      strokeWidth: 1.17646,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 1.17646,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M358.406 213.625c-9.018 2-18.587 5.975-26.125 13.438-6.987 6.917-11.634 15.083-14.312 25-2.507 9.281-2.583 14.802-1.469 24.045 1.434 11.893 8.75 23.83 8.75 23.83l12.61-2.25s-7.598-16.016-8.454-23.111c-1.027-8.523-.995-11.257 1.125-19.108 2.197-8.133 5.386-13.722 10.875-19.156 5.177-5.126 12.47-8.301 19.938-10.032 6.661-1.543 14.188-2.204 20.031-1 11.099 2.288 18.31 5.912 30.375 9.719 8.703 2.746 15.356 3.688 24.156 4.188 5.383.305 11.605-1.038 17.438-2.282 5.832-1.244 10.719-2.531 10.719-2.531l-3.282-12.594s-4.661 1.235-10.156 2.407c-5.495 1.171-12.358 2.122-13.969 2.03-8.297-.47-13.167-1.163-20.969-3.624-11.168-3.525-19.074-7.432-31.687-10.063-8.5-1.773-17.217-.764-25.594 1.094z",
    style: {
      color: "#000",
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: "medium",
      lineHeight: "normal",
      fontFamily: "'Bitstream Vera Sans'",
      InkscapeFontSpecification: "'Bitstream Vera Sans'",
      textIndent: 0,
      textAlign: "start",
      textDecoration: "none",
      textDecorationLine: "none",
      letterSpacing: "normal",
      wordSpacing: "normal",
      textTransform: "none",
      writingMode: "lr-tb",
      direction: "ltr",
      textAnchor: "start",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      fill: "#fed100",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.17646,
      marker: "none",
      enableBackground: "accumulate"
    },
    transform: "matrix(-.23459 0 0 .25269 557.991 119.83)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.406 213.625c-9.018 2-18.587 5.975-26.125 13.438-6.987 6.917-11.634 15.083-14.312 25-2.507 9.281-2.583 14.802-1.469 24.045 1.434 11.893 8.75 23.83 8.75 23.83l12.61-2.25s-7.598-16.016-8.454-23.111c-1.027-8.523-.995-11.257 1.125-19.108 2.197-8.133 5.386-13.722 10.875-19.156 5.177-5.126 12.47-8.301 19.938-10.032 6.661-1.543 14.188-2.204 20.031-1 11.099 2.288 18.31 5.912 30.375 9.719 8.703 2.746 15.356 3.688 24.156 4.188 5.383.305 11.605-1.038 17.438-2.282 5.832-1.244 10.719-2.531 10.719-2.531l-3.282-12.594s-4.661 1.235-10.156 2.407c-5.495 1.171-12.358 2.122-13.969 2.03-8.297-.47-13.167-1.163-20.969-3.624-11.168-3.525-19.074-7.432-31.687-10.063-8.5-1.773-17.217-.764-25.594 1.094z",
    style: {
      color: "#000",
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: "medium",
      lineHeight: "normal",
      fontFamily: "'Bitstream Vera Sans'",
      InkscapeFontSpecification: "'Bitstream Vera Sans'",
      textIndent: 0,
      textAlign: "start",
      textDecoration: "none",
      textDecorationLine: "none",
      letterSpacing: "normal",
      wordSpacing: "normal",
      textTransform: "none",
      writingMode: "lr-tb",
      direction: "ltr",
      textAnchor: "start",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      fill: "none",
      stroke: "#000",
      strokeWidth: 1.17646,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1,
      marker: "none",
      enableBackground: "accumulate"
    },
    transform: "matrix(-.23459 0 0 .25269 557.991 119.83)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      strokeWidth: 0.883893,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      strokeWidth: 1.76779,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2700.19 785.026a10.489 10.66 0 1 1-20.977 0 10.489 10.66 0 1 1 20.977 0z",
    transform: "matrix(-.15612 0 0 .16816 903.662 60.086)",
    style: {
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      fill: "#fff",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 1.76779,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      marker: "none",
      enableBackground: "accumulate"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      strokeWidth: 0.883893,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      strokeWidth: 1.76779,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2700.19 785.026a10.489 10.66 0 1 1-20.977 0 10.489 10.66 0 1 1 20.977 0z",
    transform: "matrix(-.15612 0 0 .16816 904.45 55.85)",
    style: {
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      fill: "#fff",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 1.76779,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      marker: "none",
      enableBackground: "accumulate"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      strokeWidth: 0.883893,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      strokeWidth: 1.76779,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2700.19 785.026a10.489 10.66 0 1 1-20.977 0 10.489 10.66 0 1 1 20.977 0z",
    transform: "matrix(-.15612 0 0 .16816 904.212 51.368)",
    style: {
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      fill: "#fff",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 1.76779,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      marker: "none",
      enableBackground: "accumulate"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      strokeWidth: 0.883893,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      strokeWidth: 1.76779,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2700.19 785.026a10.489 10.66 0 1 1-20.977 0 10.489 10.66 0 1 1 20.977 0z",
    transform: "matrix(-.15612 0 0 .16816 902.612 47.116)",
    style: {
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      fill: "#fff",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 1.76779,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      marker: "none",
      enableBackground: "accumulate"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      strokeWidth: 0.883893,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      strokeWidth: 1.76779,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2700.19 785.026a10.489 10.66 0 1 1-20.977 0 10.489 10.66 0 1 1 20.977 0z",
    transform: "matrix(-.15612 0 0 .16816 899.625 43.783)",
    style: {
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      fill: "#fff",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 1.76779,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      marker: "none",
      enableBackground: "accumulate"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      strokeWidth: 0.883893,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      strokeWidth: 1.76779,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2700.19 785.026a10.489 10.66 0 1 1-20.977 0 10.489 10.66 0 1 1 20.977 0z",
    transform: "matrix(-.15612 0 0 .16816 895.89 41.6)",
    style: {
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      fill: "#fff",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 1.76779,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      marker: "none",
      enableBackground: "accumulate"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      strokeWidth: 0.883893,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      strokeWidth: 1.76779,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2700.19 785.026a10.489 10.66 0 1 1-20.977 0 10.489 10.66 0 1 1 20.977 0z",
    transform: "matrix(-.15612 0 0 .16816 891.623 40.45)",
    style: {
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      fill: "#fff",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 1.76779,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      marker: "none",
      enableBackground: "accumulate"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      strokeWidth: 0.883893,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      strokeWidth: 1.76779,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2700.19 785.026a10.489 10.66 0 1 1-20.977 0 10.489 10.66 0 1 1 20.977 0z",
    transform: "matrix(-.15612 0 0 .16816 887.25 40.68)",
    style: {
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      fill: "#fff",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 1.76779,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      marker: "none",
      enableBackground: "accumulate"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      strokeWidth: 0.883893,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      strokeWidth: 1.76779,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2700.19 785.026a10.489 10.66 0 1 1-20.977 0 10.489 10.66 0 1 1 20.977 0z",
    transform: "matrix(-.15612 0 0 .16816 875.407 44.013)",
    style: {
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      fill: "#fff",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 1.76779,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      marker: "none",
      enableBackground: "accumulate"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      strokeWidth: 0.883893,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      strokeWidth: 1.76779,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2700.19 785.026a10.489 10.66 0 1 1-20.977 0 10.489 10.66 0 1 1 20.977 0z",
    transform: "matrix(-.15612 0 0 .16816 883.089 41.945)",
    style: {
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      fill: "#fff",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 1.76779,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      marker: "none",
      enableBackground: "accumulate"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      strokeWidth: 0.883893,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      strokeWidth: 1.76779,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2700.19 785.026a10.489 10.66 0 1 1-20.977 0 10.489 10.66 0 1 1 20.977 0z",
    transform: "matrix(-.15612 0 0 .16816 879.248 43.209)",
    style: {
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      fill: "#fff",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 1.76779,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      marker: "none",
      enableBackground: "accumulate"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 1.17646,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 1.17646,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M358.406 213.625c-9.018 2-18.587 5.975-26.125 13.438-6.987 6.917-11.634 15.083-14.312 25-2.507 9.281-2.583 14.802-1.469 24.045 1.434 11.893 8.75 23.83 8.75 23.83l12.61-2.25s-7.598-16.016-8.454-23.111c-1.027-8.523-.995-11.257 1.125-19.108 2.197-8.133 5.386-13.722 10.875-19.156 5.177-5.126 12.47-8.301 19.938-10.032 6.661-1.543 14.188-2.204 20.031-1 11.099 2.288 18.31 5.912 30.375 9.719 8.703 2.746 15.356 3.688 24.156 4.188 5.383.305 11.605-1.038 17.438-2.282 5.832-1.244 10.719-2.531 10.719-2.531l-3.282-12.594s-4.661 1.235-10.156 2.407c-5.495 1.171-12.358 2.122-13.969 2.03-8.297-.47-13.167-1.163-20.969-3.624-11.168-3.525-19.074-7.432-31.687-10.063-8.5-1.773-17.217-.764-25.594 1.094z",
    style: {
      color: "#000",
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: "medium",
      lineHeight: "normal",
      fontFamily: "'Bitstream Vera Sans'",
      InkscapeFontSpecification: "'Bitstream Vera Sans'",
      textIndent: 0,
      textAlign: "start",
      textDecoration: "none",
      textDecorationLine: "none",
      letterSpacing: "normal",
      wordSpacing: "normal",
      textTransform: "none",
      writingMode: "lr-tb",
      direction: "ltr",
      textAnchor: "start",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      fill: "#fed100",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.17646,
      marker: "none",
      enableBackground: "accumulate"
    },
    transform: "matrix(.23459 0 0 .25269 341.256 119.83)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.406 213.625c-9.018 2-18.587 5.975-26.125 13.438-6.987 6.917-11.634 15.083-14.312 25-2.507 9.281-2.583 14.802-1.469 24.045 1.434 11.893 8.75 23.83 8.75 23.83l12.61-2.25s-7.598-16.016-8.454-23.111c-1.027-8.523-.995-11.257 1.125-19.108 2.197-8.133 5.386-13.722 10.875-19.156 5.177-5.126 12.47-8.301 19.938-10.032 6.661-1.543 14.188-2.204 20.031-1 11.099 2.288 18.31 5.912 30.375 9.719 8.703 2.746 15.356 3.688 24.156 4.188 5.383.305 11.605-1.038 17.438-2.282 5.832-1.244 10.719-2.531 10.719-2.531l-3.282-12.594s-4.661 1.235-10.156 2.407c-5.495 1.171-12.358 2.122-13.969 2.03-8.297-.47-13.167-1.163-20.969-3.624-11.168-3.525-19.074-7.432-31.687-10.063-8.5-1.773-17.217-.764-25.594 1.094z",
    style: {
      color: "#000",
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: "medium",
      lineHeight: "normal",
      fontFamily: "'Bitstream Vera Sans'",
      InkscapeFontSpecification: "'Bitstream Vera Sans'",
      textIndent: 0,
      textAlign: "start",
      textDecoration: "none",
      textDecorationLine: "none",
      letterSpacing: "normal",
      wordSpacing: "normal",
      textTransform: "none",
      writingMode: "lr-tb",
      direction: "ltr",
      textAnchor: "start",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      fill: "none",
      stroke: "#000",
      strokeWidth: 1.17646,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1,
      marker: "none",
      enableBackground: "accumulate"
    },
    transform: "matrix(.23459 0 0 .25269 341.256 119.83)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      strokeWidth: 0.883893,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      strokeWidth: 1.76779,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2700.19 785.026a10.489 10.66 0 1 1-20.977 0 10.489 10.66 0 1 1 20.977 0z",
    transform: "matrix(.15612 0 0 .16816 -4.414 60.086)",
    style: {
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      fill: "#fff",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 1.76779,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      marker: "none",
      enableBackground: "accumulate"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      strokeWidth: 0.883893,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      strokeWidth: 1.76779,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2700.19 785.026a10.489 10.66 0 1 1-20.977 0 10.489 10.66 0 1 1 20.977 0z",
    transform: "matrix(.15612 0 0 .16816 -5.203 55.85)",
    style: {
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      fill: "#fff",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 1.76779,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      marker: "none",
      enableBackground: "accumulate"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      strokeWidth: 0.883893,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      strokeWidth: 1.76779,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2700.19 785.026a10.489 10.66 0 1 1-20.977 0 10.489 10.66 0 1 1 20.977 0z",
    transform: "matrix(.15612 0 0 .16816 -4.965 51.368)",
    style: {
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      fill: "#fff",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 1.76779,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      marker: "none",
      enableBackground: "accumulate"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      strokeWidth: 0.883893,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      strokeWidth: 1.76779,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2700.19 785.026a10.489 10.66 0 1 1-20.977 0 10.489 10.66 0 1 1 20.977 0z",
    transform: "matrix(.15612 0 0 .16816 -3.364 47.116)",
    style: {
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      fill: "#fff",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 1.76779,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      marker: "none",
      enableBackground: "accumulate"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      strokeWidth: 0.883893,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      strokeWidth: 1.76779,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2700.19 785.026a10.489 10.66 0 1 1-20.977 0 10.489 10.66 0 1 1 20.977 0z",
    transform: "matrix(.15612 0 0 .16816 -.377 43.783)",
    style: {
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      fill: "#fff",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 1.76779,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      marker: "none",
      enableBackground: "accumulate"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      strokeWidth: 0.883893,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      strokeWidth: 1.76779,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2700.19 785.026a10.489 10.66 0 1 1-20.977 0 10.489 10.66 0 1 1 20.977 0z",
    transform: "matrix(.15612 0 0 .16816 3.357 41.6)",
    style: {
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      fill: "#fff",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 1.76779,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      marker: "none",
      enableBackground: "accumulate"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      strokeWidth: 0.883893,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      strokeWidth: 1.76779,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2700.19 785.026a10.489 10.66 0 1 1-20.977 0 10.489 10.66 0 1 1 20.977 0z",
    transform: "matrix(.15612 0 0 .16816 7.624 40.45)",
    style: {
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      fill: "#fff",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 1.76779,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      marker: "none",
      enableBackground: "accumulate"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      strokeWidth: 0.883893,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      strokeWidth: 1.76779,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2700.19 785.026a10.489 10.66 0 1 1-20.977 0 10.489 10.66 0 1 1 20.977 0z",
    transform: "matrix(.15612 0 0 .16816 11.998 40.68)",
    style: {
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      fill: "#fff",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 1.76779,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      marker: "none",
      enableBackground: "accumulate"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      strokeWidth: 0.883893,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      strokeWidth: 1.76779,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2700.19 785.026a10.489 10.66 0 1 1-20.977 0 10.489 10.66 0 1 1 20.977 0z",
    transform: "matrix(.15612 0 0 .16816 23.84 44.013)",
    style: {
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      fill: "#fff",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 1.76779,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      marker: "none",
      enableBackground: "accumulate"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      strokeWidth: 0.883893,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      strokeWidth: 1.76779,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2700.19 785.026a10.489 10.66 0 1 1-20.977 0 10.489 10.66 0 1 1 20.977 0z",
    transform: "matrix(.15612 0 0 .16816 16.159 41.945)",
    style: {
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      fill: "#fff",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 1.76779,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      marker: "none",
      enableBackground: "accumulate"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      strokeWidth: 0.883893,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      strokeWidth: 1.76779,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2700.19 785.026a10.489 10.66 0 1 1-20.977 0 10.489 10.66 0 1 1 20.977 0z",
    transform: "matrix(.15612 0 0 .16816 20 43.209)",
    style: {
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      fill: "#fff",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 1.76779,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      marker: "none",
      enableBackground: "accumulate"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 1.17646,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 0.972282,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 0.972282,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185.96 37.047c1.567-1.984 3.44-3.458 4.956-5.475 1.594-2.12 2.81-4.798 3.436-7.503-2.771.69-5.45 1.907-7.57 3.5-2.016 1.518-3.49 3.39-5.474 4.957V7.116c1.984 1.567 3.458 3.439 5.475 4.956 2.12 1.594 4.798 2.81 7.569 3.501-.625-2.705-1.842-5.383-3.436-7.503-1.517-2.017-3.389-3.49-4.956-5.475h28.151c-1.567 1.984-3.439 3.458-4.956 5.475-1.594 2.12-2.81 4.798-3.435 7.503 2.77-.69 5.45-1.907 7.569-3.501 2.017-1.517 3.49-3.39 5.474-4.956v25.41c-1.984-1.567-3.457-3.439-5.474-4.956-2.12-1.594-4.798-2.81-7.57-3.501.626 2.705 1.842 5.383 3.436 7.503 1.517 2.017 3.39 3.49 4.956 5.475z",
    style: {
      display: "inline",
      fill: "#fed100",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.972282,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(.28385 0 0 .30575 392.844 156.536)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      strokeWidth: 0.73049,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      strokeWidth: 1.46098,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2700.19 785.026a10.489 10.66 0 1 1-20.977 0 10.489 10.66 0 1 1 20.977 0z",
    transform: "matrix(.1889 0 0 .20348 -58.467 2.86)",
    style: {
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      fill: "#fff",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 1.46098,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      marker: "none",
      enableBackground: "accumulate"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 1.24742,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      strokeWidth: 0.674872,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2700.19 785.026a10.489 10.66 0 1 1-20.977 0 10.489 10.66 0 1 1 20.977 0z",
    transform: "matrix(.42875 0 0 .45439 -703.591 -183.976)",
    style: {
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      fill: "#fed100",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.64894,
      marker: "none",
      enableBackground: "accumulate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2700.19 785.026a10.489 10.66 0 1 1-20.977 0 10.489 10.66 0 1 1 20.977 0z",
    transform: "matrix(.42875 0 0 .45439 -703.591 -183.976)",
    style: {
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.64894,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      marker: "none",
      enableBackground: "accumulate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 1.24742,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M195.844 28.438V45.5H178.78v8.688h42.813V45.5H204.5V28.437z",
    style: {
      fill: "#fed100",
      fillOpacity: 1,
      stroke: "none"
    },
    transform: "matrix(.22124 0 0 .23831 405.334 160.738)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.844 28.437V45.5H178.78v8.687h42.813V45.5H204.5V28.437z",
    style: {
      display: "inline",
      fill: "none",
      stroke: "#000",
      strokeWidth: 1.24742,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(.22124 0 0 .23831 405.334 160.738)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 1.17646,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 1.17646,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 1.17646,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    transform: "matrix(.23459 0 0 .25269 403.883 167.747)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.322,
    height: 71.72,
    ry: 6.386,
    x: 182.326,
    y: 34.934,
    style: {
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      fill: "#fed100",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1.17646,
      marker: "none",
      enableBackground: "accumulate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 25.322,
    height: 71.72,
    ry: 6.386,
    x: 182.326,
    y: 34.934,
    style: {
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      fill: "none",
      stroke: "#000",
      strokeWidth: 1.17646,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      marker: "none",
      enableBackground: "accumulate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      strokeWidth: 1.17646,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 1.17646,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.26907 0 0 .22912 385.928 -39.096)",
    style: {
      strokeWidth: 1.1536,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.041,
    height: 79.256,
    ry: 3.8,
    x: 221.335,
    y: 941.218,
    style: {
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      fill: "#fed100",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1.1536,
      marker: "none",
      enableBackground: "accumulate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.855 941.218c1.95 0 3.52 1.694 3.52 3.8v71.655c0 2.105-1.57 3.8-3.52 3.8s-3.52-1.695-3.52-3.8v-71.656c0-2.105 1.57-3.8 3.52-3.8z",
    style: {
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      fill: "none",
      stroke: "#000",
      strokeWidth: 1.1536,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      marker: "none",
      enableBackground: "accumulate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.26907 0 0 .22912 387.161 -39.096)",
    style: {
      strokeWidth: 1.1536,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.041,
    height: 79.256,
    ry: 3.8,
    x: 240.494,
    y: 941.218,
    style: {
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      fill: "#fed100",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1.1536,
      marker: "none",
      enableBackground: "accumulate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.041,
    height: 79.256,
    ry: 3.8,
    x: 240.494,
    y: 941.218,
    style: {
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      fill: "none",
      stroke: "#000",
      strokeWidth: 1.1536,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      marker: "none",
      enableBackground: "accumulate"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 1.17646,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      strokeWidth: 0.883893,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      strokeWidth: 1.76779,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2700.19 785.026a10.489 10.66 0 1 1-20.977 0 10.489 10.66 0 1 1 20.977 0z",
    transform: "matrix(.15612 0 0 .16816 29.714 44.948)",
    style: {
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      fill: "#fff",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 1.76779,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      marker: "none",
      enableBackground: "accumulate"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      strokeWidth: 0.883893,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      strokeWidth: 1.76779,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2700.19 785.026a10.489 10.66 0 1 1-20.977 0 10.489 10.66 0 1 1 20.977 0z",
    transform: "matrix(.15612 0 0 .16816 29.714 48.512)",
    style: {
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      fill: "#fff",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 1.76779,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      marker: "none",
      enableBackground: "accumulate"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      strokeWidth: 0.883893,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      strokeWidth: 1.76779,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2700.19 785.026a10.489 10.66 0 1 1-20.977 0 10.489 10.66 0 1 1 20.977 0z",
    transform: "matrix(.15612 0 0 .16816 29.714 52.082)",
    style: {
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      fill: "#fff",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 1.76779,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      marker: "none",
      enableBackground: "accumulate"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      strokeWidth: 0.883893,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      strokeWidth: 1.76779,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2700.19 785.026a10.489 10.66 0 1 1-20.977 0 10.489 10.66 0 1 1 20.977 0z",
    transform: "matrix(.15612 0 0 .16816 29.714 55.652)",
    style: {
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      fill: "#fff",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 1.76779,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      marker: "none",
      enableBackground: "accumulate"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      strokeWidth: 0.883893,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      strokeWidth: 1.76779,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2700.19 785.026a10.489 10.66 0 1 1-20.977 0 10.489 10.66 0 1 1 20.977 0z",
    transform: "matrix(.15612 0 0 .16816 29.714 59.222)",
    style: {
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      fill: "#fff",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 1.76779,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      marker: "none",
      enableBackground: "accumulate"
    }
  }))))))), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 1.17646,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 1.17646,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 1.17646,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 1.17646,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-147.292 1086.949c-6.72 15.023-12.101 29.69-17.375 44.782h-216.625c-5.098-14.589-10.297-30.282-16.708-44.782 0 0 13.482 18.865 23.579 23.427 5.608 2.534 12.622 3.29 18.42 1.228 7.642-2.717 17.808-16.58 17.808-16.58s9.14 10.7 15.35 13.51c5.83 2.638 12.645 2.745 19.036 2.456 5.655-.256 11.92-.469 16.579-3.684 7.055-4.87 14.123-21.492 14.123-21.492s6.838 13.078 12.28 17.807c4.492 3.903 10.131 6.816 15.965 7.983 5.835 1.167 12.21.79 17.808-1.228 7.587-2.736 19.649-14.123 19.649-14.123s8.301 10.296 14.123 12.895c5.635 2.515 12.414 3.255 18.42 1.842 6.358-1.496 11.699-6.1 16.58-10.439 4.356-3.872 10.988-13.602 10.988-13.602z",
    style: {
      display: "inline",
      fill: "#fed100",
      fillOpacity: 1,
      stroke: "none"
    },
    transform: "matrix(.23459 0 0 .25269 513.583 -72.093)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-147.292 1086.949c-6.72 15.023-12.101 29.69-17.375 44.782h-216.625c-5.098-14.589-10.297-30.282-16.708-44.782 0 0 13.482 18.865 23.579 23.427 5.608 2.534 12.622 3.29 18.42 1.228 7.642-2.717 17.808-16.58 17.808-16.58s9.14 10.7 15.35 13.51c5.83 2.638 12.645 2.745 19.036 2.456 5.655-.256 11.92-.469 16.579-3.684 7.055-4.87 14.123-21.492 14.123-21.492s6.838 13.078 12.28 17.807c4.492 3.903 10.131 6.816 15.965 7.983 5.835 1.167 12.21.79 17.808-1.228 7.587-2.736 19.649-14.123 19.649-14.123s8.301 10.296 14.123 12.895c5.635 2.515 12.414 3.255 18.42 1.842 6.358-1.496 11.699-6.1 16.58-10.439 4.356-3.872 10.988-13.602 10.988-13.602z",
    style: {
      display: "inline",
      fill: "none",
      stroke: "#000",
      strokeWidth: 1.17646,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(.23459 0 0 .25269 513.583 -72.093)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 1.17646,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-272.646 1095.46s-4.94 7.603-7.977 10.201c-4.218 3.608-6.992 5.781-12.41 7.49-5.409 1.704-12.953 2.663-18.616 2.353-5.477-.3-11.112-1.888-16.048-4.28-4.29-2.078-11.127-8.13-11.127-8.13-3.323 4.311-7.555 7.34-11.582 9.578-5.15 2.862-10.24 3.12-15.586 2.832-10.867-.586-21.005-7.374-29.137-21.138-5.273-12.47-11.337-25.099-18.912-38.341 8.73-3.09 18.903-4.736 30.187-5.27-4.59 12.93-9.35 25.527-7.666 35.936 9.48-7.1 12.547-16.767 15.812-26.354l11.02 38.812c-6.689-1.173-3.131-2.555-20.698-5.885 3.52 6.637 11.578 14.832 20.462 15.639 5.974.542 10.31-1.303 14.107-4.597 2.728-2.365 5.215-5.494 5.182-9.02l-.056-6.055c-.012-1.297-1.613-3.133-2.91-3.151-1.235-.017-1.577 1.988-1.907 3.18-.66 2.382.665 5.036 0 7.418-.734 2.626-2.14 4.7-4.451 6.147-1.925 1.205-6.57 1.483-6.57 1.483l1.483-5.723c1.047-4.037-2.873-7.17-3.815-11.233-.607-2.616-.942-5.54 0-8.055 1.018-2.72 3.079-5.367 5.722-6.57.965-.44 2.123-.5 3.18-.424 1.495.106 4.45 1.06 4.45 1.06s-.847-4.091-.635-6.571c.258-3.008 2.805-8.578 4.24-11.234 2.38-4.41 6.168-8.383 6.6-8.81.414.417 4.519 4.237 7.202 8.471 1.615 2.55 3.272 6.234 3.738 9.216.385 2.459.247 7.659.247 7.659s4.366-1.793 5.85-2.003c1.05-.148 2.209-.17 3.201.202 2.721 1.016 4.961 3.514 6.167 6.156 1.114 2.443.983 5.384.56 8.035-.658 4.119-3.078 7.306-1.753 11.26l1.878 5.606s-4.654.046-6.658-1.023c-2.405-1.283-3.953-3.254-4.868-5.822-.829-2.33-.348-5.183-1.787-7.189-.637-.887-1.529-1.87-2.76-1.767-1.293.108-2.2 2.22-2.255 3.516l-.228 5.451c-.07 1.675.693 3.416 1.59 4.77 2.197 3.321 5.467 5.335 9.157 6.83 3.997 1.62 7.601 2.243 11.913 2.294 3.598.042 9.85-.548 13.258-1.7 4.2-1.418 6.67-3.22 9.918-6.235 1.83-1.7 3.054-4.169 3.86-6.533.928-2.724.594-7.424.594-7.424-4.178 1.584-7.811 3.713-11.086 6.2-3.7 2.812-6.943 6.081-9.998 9.538l-.297-46.919c4.353 4.802 7.518 9.103 11.87 12.719 3.665 3.045 5.549 4.206 9.214 5.396-1.047-3.775-1.4-6.064-4.103-9.839-3.747-5.233-7.396-10.852-11.933-16.085 8.354-1.391 16.702-1.766 25.167-1.766s16.813.375 25.167 1.766c-4.537 5.233-8.186 10.852-11.933 16.085-2.702 3.775-3.056 6.064-4.103 9.839 3.665-1.19 5.549-2.351 9.214-5.396 4.353-3.616 7.517-7.917 11.87-12.719l-.297 46.92c-3.055-3.458-6.297-6.727-9.998-9.539-3.274-2.487-6.907-4.616-11.086-6.2 0 0-.334 4.7.594 7.424.806 2.364 2.03 4.833 3.86 6.533 3.25 3.015 5.719 4.817 9.918 6.236 3.409 1.151 9.66 1.74 13.258 1.699 4.312-.05 7.917-.673 11.913-2.293 3.69-1.496 6.96-3.51 9.158-6.83.897-1.355 1.66-3.096 1.59-4.77l-.229-5.452c-.054-1.296-.962-3.408-2.254-3.516-1.232-.103-2.123.88-2.76 1.767-1.44 2.006-.959 4.86-1.788 7.189-.915 2.568-2.463 4.539-4.868 5.822-2.004 1.069-6.658 1.023-6.658 1.023l1.878-5.606c1.325-3.954-1.095-7.141-1.753-11.26-.423-2.651-.553-5.592.56-8.035 1.206-2.642 3.446-5.14 6.167-6.156.993-.371 2.152-.35 3.201-.202 1.484.21 5.85 2.003 5.85 2.003s-.137-5.2.247-7.659c.466-2.982 2.123-6.666 3.739-9.216 2.682-4.234 6.787-8.054 7.202-8.471.432.427 4.219 4.4 6.6 8.81 1.434 2.656 3.982 8.226 4.24 11.234.212 2.48-.637 6.57-.637 6.57s2.957-.953 4.452-1.06c1.057-.074 2.214-.014 3.179.425 2.644 1.203 4.704 3.85 5.723 6.57.941 2.515.607 5.44 0 8.055-.943 4.063-4.862 7.196-3.815 11.233l1.483 5.723s-4.646-.278-6.57-1.483c-2.31-1.448-3.718-3.521-4.452-6.147-.665-2.382.66-5.036 0-7.419-.33-1.19-.671-3.196-1.907-3.18-1.297.019-2.898 1.855-2.91 3.152l-.056 6.056c-.032 3.525 2.455 6.654 5.182 9.02 3.798 3.293 8.134 5.138 14.107 4.596 8.884-.807 16.942-9.002 20.462-15.64-17.566 3.33-14.009 4.713-20.698 5.886l11.02-38.812c3.266 9.587 6.332 19.253 15.813 26.354 1.684-10.409-3.077-23.006-7.667-35.937 11.284.535 21.457 2.181 30.187 5.27-7.574 13.243-13.639 25.872-18.912 38.342-8.132 13.764-18.27 20.552-29.137 21.138-5.346.288-10.435.03-15.585-2.832-4.028-2.238-8.26-5.267-11.583-9.579 0 0-6.836 6.053-11.127 8.132-4.936 2.391-10.57 3.979-16.048 4.28-5.662.31-13.207-.65-18.616-2.355-5.418-1.708-8.192-3.881-12.41-7.489-3.037-2.598-7.977-10.2-7.977-10.2z",
    style: {
      display: "inline",
      fill: "#fed100",
      fillOpacity: 1,
      stroke: "none"
    },
    transform: "matrix(.23459 0 0 .25269 513.583 -72.093)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-365.992 1115.504c-10.867-.586-21.005-7.374-29.137-21.138-5.273-12.47-11.337-25.099-18.912-38.341 8.73-3.09 18.903-4.736 30.187-5.27-4.59 12.93-9.35 25.527-7.666 35.936 9.48-7.1 12.547-16.767 15.812-26.354l11.02 38.812c-6.689-1.173-3.131-2.555-20.698-5.885 3.52 6.637 11.578 14.832 20.462 15.639zm185.624-6.601c8.884-.807 16.942-9.002 20.462-15.64-17.566 3.33-14.009 4.713-20.698 5.886l11.02-38.812c3.266 9.587 6.332 19.253 15.813 26.354 1.684-10.409-3.077-23.006-7.667-35.937 11.284.535 21.457 2.181 30.187 5.27-7.574 13.243-13.639 25.872-18.912 38.342-8.132 13.764-18.27 20.552-29.137 21.138l-.208.384z",
    style: {
      display: "inline",
      fill: "#fed100",
      fillOpacity: 1,
      stroke: "none"
    },
    transform: "matrix(.23459 0 0 .25269 513.583 -72.093)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-311.649 1115.504c-5.477-.3-11.112-1.888-16.048-4.28-4.29-2.078-11.127-8.13-11.127-8.13-3.323 4.311-7.555 7.34-11.582 9.578-5.15 2.862-10.24 3.12-15.586 2.832l-.188 1.873 1.256-8.474c5.974.542 10.31-1.303 14.107-4.597 2.728-2.365 5.215-5.494 5.182-9.02l-.056-6.055c-.012-1.297-1.613-3.133-2.91-3.151-1.235-.017-1.577 1.988-1.907 3.18-.66 2.382.665 5.036 0 7.418-.734 2.626-2.14 4.7-4.451 6.147-1.925 1.205-6.57 1.483-6.57 1.483l1.483-5.723c1.047-4.037-2.873-7.17-3.815-11.233-.607-2.616-.942-5.54 0-8.055 1.018-2.72 3.079-5.367 5.722-6.57.965-.44 2.123-.5 3.18-.424 1.495.106 4.45 1.06 4.45 1.06s-.847-4.091-.635-6.571c.258-3.008 2.805-8.578 4.24-11.234 2.38-4.41 6.168-8.383 6.6-8.81.414.417 4.519 4.237 7.202 8.471 1.615 2.55 3.272 6.234 3.738 9.216.385 2.459.247 7.659.247 7.659s4.366-1.793 5.85-2.003c1.05-.148 2.209-.17 3.201.202 2.721 1.016 4.961 3.514 6.167 6.156 1.114 2.443.983 5.384.56 8.035-.658 4.119-3.078 7.306-1.753 11.26l1.878 5.606s-4.654.046-6.658-1.023c-2.405-1.283-3.953-3.254-4.868-5.822-.829-2.33-.348-5.183-1.787-7.189-.637-.887-1.529-1.87-2.76-1.767-1.293.108-2.2 2.22-2.255 3.516l-.228 5.451c-.07 1.675.693 3.416 1.59 4.77 2.197 3.321 5.467 5.335 9.157 6.83 3.997 1.62 7.601 2.243 11.913 2.294z",
    style: {
      display: "inline",
      fill: "#fed100",
      fillOpacity: 1,
      stroke: "none"
    },
    transform: "matrix(.23459 0 0 .25269 513.583 -72.093)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-203.848 1095.145-.126-.21c-.15-2.57.719-6.97.719-6.97.484-2.19 2.361-4.532 4.687-5.374 1.254-.455 2.777-.629 4.125.03.823.403 1.486.715 2.032 1.282.545.567.884 1.312 1.25 2.375.535 1.553.302 3.174.03 4.562-.446 2.291-.396 4.294.25 5.844.458 1.095 1.378 1.916 2.563 2.625-.22-.783-.379-1.163-.5-2.031-.179-1.288.039-2.617.532-3.781.858-2.029 2.042-3.627 2.843-5.407.764-1.697 1.164-3.62 1.032-5.437-.11-1.5-.552-3.048-1.407-4.125-.926-1.168-2.34-2.137-3.75-2.406-1.254-.24-3.315.187-4.968.718-1.654.532-2.907 1.125-2.907 1.125l-1.468.688.25-1.594c.859-5.36 1.618-8.081 0-13.094-.666-2.06-1.777-4.334-3.657-6.968-.912-1.28-1.932-2.808-3.093-4.22-3.028 3.448-5.14 6.94-6.344 10.47-1.32 3.863-1.372 9-1.063 13.125l.125 1.656-1.406-.844s-1.599-.98-3.531-1.906c-1.933-.926-4.288-1.743-5.281-1.656-1.874.164-3.125 1.06-4.344 2.625-1.035 1.328-1.258 2.48-1.469 4.312-.133 1.158.158 3.335.344 4.75.217 1.659 1.194 3.403 1.469 5.5.09.693.305 1.237.468 1.906.163.67.245 1.455.063 2.375-.126.637-.314 1.096-.563 1.875.48-.232.81-.349 1.063-.53.927-.667 1.303-1.849 1.906-3.282.324-.772.396-1.464.438-2.281.041-.817.082-1.778.5-2.844.714-1.821 1.554-3.984 3.406-5.313 1.516-1.087 3.538-1.39 5.312-.843 1.051.323 1.803.972 2.344 1.718.54.747.904 1.563 1.281 2.375.484 1.04.773 2.598 1 3.97a44.76 44.76 0 0 1 .344 2.53l.031.125-.03.157-1.292 4.291-1.646-.37 1.25-4.105a60.172 60.172 0 0 0-.344-2.344c-.219-1.32-.55-2.897-.844-3.53-.387-.833-.735-1.556-1.125-2.095-.39-.539-.786-.883-1.469-1.093-1.223-.377-2.81-.147-3.843.593-1.311.94-2.106 2.76-2.813 4.563-.307.783-.333 1.487-.375 2.312-.042.825-.086 1.785-.531 2.844-.552 1.312-1.009 2.928-2.5 4-1.1.79-3.094 1.563-3.094 1.563l-1.75.718.625-1.78s.881-2.614 1.063-3.532c.125-.636.074-1.095-.063-1.656-.137-.562-.385-1.214-.5-2.094-.217-1.659-1.194-3.403-1.469-5.5-.179-1.367-.531-3.527-.343-5.156.219-1.901.538-3.552 1.812-5.188 1.396-1.792 3.166-3.043 5.531-3.25 1.87-.164 4.17.846 6.188 1.813 1.298.621 1.692.907 2.344 1.28-.212-3.959-.148-8.526 1.156-12.343 1.382-4.047 3.75-8.036 7.344-11.906l.625-.656.625.656c1.67 1.798 2.812 3.772 3.843 5.219 1.967 2.757 3.185 5.202 3.907 7.437 1.546 4.788.979 8.057.25 12.469.569-.24.767-.372 1.75-.688 1.767-.568 3.922-1.105 5.78-.75 1.902.363 3.614 1.528 4.782 3 1.16 1.462 1.655 3.33 1.781 5.063.157 2.15-.318 4.35-1.187 6.281-.899 1.997-2.088 3.589-2.844 5.375-.38.9-.567 1.943-.437 2.875.194 1.396.937 3.656.937 3.656l.531 1.594-1.625-.531c-2.593-.88-4.292-2.474-5.125-4.469-.833-1.995-.829-4.324-.343-6.812.254-1.307.39-2.613.03-3.657-.332-.965-.574-1.437-.874-1.75-.3-.312-.762-.546-1.563-.937-.739-.362-1.88-.306-2.812.03-1.546.56-3.395 2.628-3.563 4.095-.296 2.589-1.03 5.222-2.28 6.863zm48.75-3.052.437-.875-.938-.312c-6.98-2.21-13.424-.538-19.5 2.031a134.46 134.46 0 0 0 5.656-20.125c6.625 11.903 12.246 15.797 17.532 18.219l.968.437.22-1.062c1.576-8.127 1.698-18.955-4.97-35.063 7.472.388 14.902 1.284 22.282 4.563l.687-1.563c-8.101-3.6-16.193-4.494-24.187-4.844l-1.375-.062.562 1.25c6.848 15.897 6.849 26.243 5.469 34.22-5.079-2.472-10.219-6.205-16.781-18.72l-1.157-2.187-.437 2.438c-1.426 7.888-3.65 15.789-6.656 23.687l-.75 1.938 1.875-.876c6.136-2.784 12.342-4.598 19.03-2.843l.166.103zm-233.064.25c6.68-1.743 12.871.062 19 2.844l1.875.875-.718-1.937c-3.007-7.898-5.231-15.799-6.657-23.688l-.437-2.437-1.156 2.188c-6.565 12.52-11.732 16.247-16.813 18.718-1.38-7.976-1.347-18.322 5.5-34.219l.531-1.25-1.343.063c-7.994.35-16.086 1.244-24.188 4.843l.688 1.563c7.388-3.283 14.8-4.176 22.281-4.563-6.668 16.108-6.546 26.936-4.969 35.063l.188 1.062 1-.437c5.281-2.42 10.913-6.305 17.531-18.188a134.566 134.566 0 0 0 5.656 20.094c-6.076-2.569-12.52-4.241-19.5-2.031l-.937.312.437.875-.18.091 2.211.16zm54.884 3.778-.977-3.652c.017-.154.11-1.031.312-2.25.219-1.321.58-2.898.875-3.531.387-.833.735-1.555 1.125-2.094.39-.54.787-.884 1.469-1.094 1.223-.377 2.78-.147 3.812.594 1.311.94 2.138 2.76 2.844 4.562.307.783.333 1.488.375 2.313.042.825.086 1.784.531 2.844.552 1.312 1.009 2.928 2.5 4 1.1.79 3.094 1.562 3.094 1.562l1.719.719-.594-1.781s-.88-2.614-1.062-3.532c-.126-.635-.075-1.094.062-1.656.137-.562.354-1.214.469-2.094.217-1.659 1.194-3.403 1.469-5.5.179-1.366.562-3.526.375-5.156-.22-1.901-.538-3.551-1.813-5.188-1.396-1.792-3.165-3.042-5.531-3.25-1.87-.163-4.17.846-6.188 1.813-1.297.622-1.692.908-2.343 1.281.211-3.96.147-8.526-1.157-12.344-1.382-4.047-3.75-8.036-7.343-11.906l-.625-.656-.625.656c-1.67 1.798-2.844 3.773-3.875 5.219-1.967 2.757-3.154 5.202-3.875 7.438-1.546 4.788-.98 8.056-.25 12.468-.57-.24-.76-.369-1.75-.687-1.768-.568-3.922-1.106-5.782-.75-1.9.363-3.613 1.527-4.78 3-1.16 1.462-1.656 3.33-1.782 5.062-.156 2.15.319 4.351 1.187 6.281.9 1.998 2.088 3.59 2.844 5.376.38.899.536 1.942.406 2.874-.194 1.396-.906 3.657-.906 3.657l-.531 1.594 1.625-.532c2.594-.88 4.292-2.474 5.125-4.469.833-1.994.829-4.323.344-6.812-.255-1.307-.39-2.613-.032-3.656.333-.966.575-1.438.875-1.75.3-.312.731-.546 1.532-.938.739-.361 1.912-.306 2.843.031 1.546.56 3.232 2.65 3.563 4.094v.03c.008.043.806 4.51.687 6.532l2.006.355c-.167-2.83-1.037-7.23-1.037-7.23-.484-2.19-2.33-4.532-4.656-5.374-1.254-.454-2.807-.629-4.156.03-.823.403-1.455.715-2 1.282-.546.567-.916 1.312-1.282 2.375-.534 1.554-.302 3.174-.03 4.563.446 2.29.397 4.293-.25 5.843-.458 1.095-1.346 1.916-2.532 2.625.22-.783.38-1.163.5-2.031.18-1.287-.038-2.617-.531-3.781-.859-2.028-2.043-3.627-2.844-5.406-.764-1.698-1.195-3.62-1.062-5.438.108-1.5.551-3.048 1.406-4.125.926-1.168 2.37-2.137 3.781-2.406 1.255-.24 3.284.187 4.938.719a28.784 28.784 0 0 1 2.937 1.125l1.469.687-.281-1.594c-.86-5.36-1.588-8.081.03-13.093.666-2.061 1.746-4.334 3.626-6.97.913-1.28 1.962-2.806 3.125-4.218 3.027 3.446 5.139 6.94 6.343 10.469 1.32 3.863 1.34 9 1.032 13.125l-.094 1.656 1.406-.844s1.568-.98 3.5-1.906c1.933-.926 4.319-1.743 5.313-1.656 1.874.164 3.124 1.06 4.344 2.625 1.034 1.328 1.257 2.48 1.468 4.312.134 1.158-.19 3.335-.375 4.75-.217 1.66-1.162 3.404-1.437 5.5-.091.693-.306 1.237-.469 1.907-.163.669-.276 1.454-.094 2.375.126.636.314 1.096.563 1.875-.48-.233-.809-.35-1.063-.532-.927-.666-1.303-1.848-1.906-3.281-.324-.771-.364-1.464-.406-2.281-.042-.817-.082-1.778-.5-2.844-.714-1.821-1.554-3.984-3.406-5.312-1.516-1.088-3.539-1.39-5.313-.844a4.577 4.577 0 0 0-2.375 1.719c-.54.746-.872 1.562-1.25 2.375-.484 1.04-.773 2.597-1 3.968a76.772 76.772 0 0 0-.375 2.532v.125l.031.156 1.009 3.746.497.054 1.159-.428zm64.68-13.84.03-1.062 1.032.25c4.755 1.192 8.39 2.803 11.406 4.593 3.827 2.272 6.653 4.822 9.625 7.282l.5-28.22c-2.533 2.797-4.91 5.792-8.406 8.188-2.856 1.957-8.21 4.529-13.22 5.094l-1.187.125.25-1.156c.705-3.18.685-5.39 2.282-9.156 1.514-3.574 4.708-8.757 11.062-17.438-5.495-.607-10.283-1.281-17.437-1.281-7.153 0-11.913.674-17.407 1.281 6.354 8.68 9.548 13.864 11.063 17.438 1.596 3.767 1.576 5.975 2.281 9.156l.25 1.156-1.187-.125c-5.01-.565-10.364-3.137-13.22-5.094-3.482-2.386-5.884-5.369-8.405-8.156l.5 28.156c2.96-2.45 5.812-4.987 9.625-7.25 3.016-1.79 6.62-3.401 11.375-4.593l1.062-.25v1.062l-1.713 1.198c-4.015 1.13-7.225 2.494-9.85 4.052-4.203 2.495-7.24 5.408-10.812 8.25l-1.344 1.063-.031-1.719-.531-32.188-.063-2.125 1.5 1.5c3.298 3.326 5.77 6.953 9.625 9.594 2.377 1.629 7.037 3.807 11.313 4.563-.477-2.563-.686-4.568-1.969-7.594-1.502-3.545-4.595-8.74-11.656-18.281l-.875-1.188 1.468-.156c6.085-.63 11.106-1.469 19-1.469 7.895 0 12.916.839 19 1.47l1.5.156-.874 1.187c-7.062 9.541-10.186 14.737-11.688 18.282-1.287 3.036-1.457 5.047-1.937 7.625 4.277-.755 8.903-2.965 11.28-4.594 3.855-2.642 6.359-6.268 9.657-9.594l1.469-1.5-.031 2.125-.563 32.188v1.718l-1.375-1.062c-3.572-2.842-6.578-5.755-10.781-8.25-2.625-1.558-5.835-2.922-9.844-4.031z",
    style: {
      color: "#000",
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: "medium",
      lineHeight: "normal",
      fontFamily: "'Bitstream Vera Sans'",
      InkscapeFontSpecification: "'Bitstream Vera Sans'",
      textIndent: 0,
      textAlign: "start",
      textDecoration: "none",
      textDecorationLine: "none",
      letterSpacing: "normal",
      wordSpacing: "normal",
      textTransform: "none",
      writingMode: "lr-tb",
      direction: "ltr",
      textAnchor: "start",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      fill: "#000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.17646,
      marker: "none",
      enableBackground: "accumulate"
    },
    transform: "matrix(.23459 0 0 .25269 513.583 -72.093)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-272.646 1095.46s-4.94 7.603-7.977 10.201c-4.218 3.608-6.992 5.781-12.41 7.49-5.409 1.704-12.953 2.663-18.616 2.353-5.477-.3-11.112-1.888-16.048-4.28-4.29-2.078-11.127-8.13-11.127-8.13-3.323 4.311-7.555 7.34-11.582 9.578-5.15 2.862-10.24 3.12-15.586 2.832-10.867-.586-21.005-7.374-29.137-21.138-5.273-12.47-11.337-25.099-18.912-38.341 8.73-3.09 18.903-4.736 30.187-5.27-4.59 12.93-9.35 25.527-7.666 35.936 9.48-7.1 12.547-16.767 15.812-26.354l11.02 38.812c-6.689-1.173-3.131-2.555-20.698-5.885 3.52 6.637 11.578 14.832 20.462 15.639 5.974.542 10.31-1.303 14.107-4.597 2.728-2.365 5.215-5.494 5.182-9.02l-.056-6.055c-.012-1.297-1.613-3.133-2.91-3.151-1.235-.017-1.577 1.988-1.907 3.18-.66 2.382.665 5.036 0 7.418-.734 2.626-2.14 4.7-4.451 6.147-1.925 1.205-6.57 1.483-6.57 1.483l1.483-5.723c1.047-4.037-2.873-7.17-3.815-11.233-.607-2.616-.942-5.54 0-8.055 1.018-2.72 3.079-5.367 5.722-6.57.965-.44 2.123-.5 3.18-.424 1.495.106 4.45 1.06 4.45 1.06s-.847-4.091-.635-6.571c.258-3.008 2.805-8.578 4.24-11.234 2.38-4.41 6.168-8.383 6.6-8.81.414.417 4.519 4.237 7.202 8.471 1.615 2.55 3.272 6.234 3.738 9.216.385 2.459.247 7.659.247 7.659s4.366-1.793 5.85-2.003c1.05-.148 2.209-.17 3.201.202 2.721 1.016 4.961 3.514 6.167 6.156 1.114 2.443.983 5.384.56 8.035-.658 4.119-3.078 7.306-1.753 11.26l1.878 5.606s-4.654.046-6.658-1.023c-2.405-1.283-3.953-3.254-4.868-5.822-.829-2.33-.348-5.183-1.787-7.189-.637-.887-1.529-1.87-2.76-1.767-1.293.108-2.2 2.22-2.255 3.516l-.228 5.451c-.07 1.675.693 3.416 1.59 4.77 2.197 3.321 5.467 5.335 9.157 6.83 3.997 1.62 7.601 2.243 11.913 2.294 3.598.042 9.85-.548 13.258-1.7 4.2-1.418 6.67-3.22 9.918-6.235 1.83-1.7 3.054-4.169 3.86-6.533.928-2.724.594-7.424.594-7.424-4.178 1.584-7.811 3.713-11.086 6.2-3.7 2.812-6.943 6.081-9.998 9.538l-.297-46.919c4.353 4.802 7.518 9.103 11.87 12.719 3.665 3.045 5.549 4.206 9.214 5.396-1.047-3.775-1.4-6.064-4.103-9.839-3.747-5.233-7.396-10.852-11.933-16.085 8.354-1.391 16.702-1.766 25.167-1.766s16.813.375 25.167 1.766c-4.537 5.233-8.186 10.852-11.933 16.085-2.702 3.775-3.056 6.064-4.103 9.839 3.665-1.19 5.549-2.351 9.214-5.396 4.353-3.616 7.517-7.917 11.87-12.719l-.297 46.92c-3.055-3.458-6.297-6.727-9.998-9.539-3.274-2.487-6.907-4.616-11.086-6.2 0 0-.334 4.7.594 7.424.806 2.364 2.03 4.833 3.86 6.533 3.25 3.015 5.719 4.817 9.918 6.236 3.409 1.151 9.66 1.74 13.258 1.699 4.312-.05 7.917-.673 11.913-2.293 3.69-1.496 6.96-3.51 9.158-6.83.897-1.355 1.66-3.096 1.59-4.77l-.229-5.452c-.054-1.296-.962-3.408-2.254-3.516-1.232-.103-2.123.88-2.76 1.767-1.44 2.006-.959 4.86-1.788 7.189-.915 2.568-2.463 4.539-4.868 5.822-2.004 1.069-6.658 1.023-6.658 1.023l1.878-5.606c1.325-3.954-1.095-7.141-1.753-11.26-.423-2.651-.553-5.592.56-8.035 1.206-2.642 3.446-5.14 6.167-6.156.993-.371 2.152-.35 3.201-.202 1.484.21 5.85 2.003 5.85 2.003s-.137-5.2.247-7.659c.466-2.982 2.123-6.666 3.739-9.216 2.682-4.234 6.787-8.054 7.202-8.471.432.427 4.219 4.4 6.6 8.81 1.434 2.656 3.982 8.226 4.24 11.234.212 2.48-.637 6.57-.637 6.57s2.957-.953 4.452-1.06c1.057-.074 2.214-.014 3.179.425 2.644 1.203 4.704 3.85 5.723 6.57.941 2.515.607 5.44 0 8.055-.943 4.063-4.862 7.196-3.815 11.233l1.483 5.723s-4.646-.278-6.57-1.483c-2.31-1.448-3.718-3.521-4.452-6.147-.665-2.382.66-5.036 0-7.419-.33-1.19-.671-3.196-1.907-3.18-1.297.019-2.898 1.855-2.91 3.152l-.056 6.056c-.032 3.525 2.455 6.654 5.182 9.02 3.798 3.293 8.134 5.138 14.107 4.596 8.884-.807 16.942-9.002 20.462-15.64-17.566 3.33-14.009 4.713-20.698 5.886l11.02-38.812c3.266 9.587 6.332 19.253 15.813 26.354 1.684-10.409-3.077-23.006-7.667-35.937 11.284.535 21.457 2.181 30.187 5.27-7.574 13.243-13.639 25.872-18.912 38.342-8.132 13.764-18.27 20.552-29.137 21.138-5.346.288-10.435.03-15.585-2.832-4.028-2.238-8.26-5.267-11.583-9.579 0 0-6.836 6.053-11.127 8.132-4.936 2.391-10.57 3.979-16.048 4.28-5.662.31-13.207-.65-18.616-2.355-5.418-1.708-8.192-3.881-12.41-7.489-3.037-2.598-7.977-10.2-7.977-10.2z",
    style: {
      display: "inline",
      fill: "none",
      stroke: "#000",
      strokeWidth: 1.17646,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(.23459 0 0 .25269 513.583 -72.093)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 1.17646,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 0.803539,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      strokeWidth: 1.60708,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2700.19 785.026a10.489 10.66 0 1 1-20.977 0 10.489 10.66 0 1 1 20.977 0z",
    transform: "matrix(.17173 0 0 .18498 -12.277 55.517)",
    style: {
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      fill: "#fff",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 1.60708,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      marker: "none",
      enableBackground: "accumulate"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      strokeWidth: 0.803539,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      strokeWidth: 1.60708,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2700.19 785.026a10.489 10.66 0 1 1-20.977 0 10.489 10.66 0 1 1 20.977 0z",
    transform: "matrix(.17173 0 0 .18498 -40.775 58.23)",
    style: {
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      fill: "#fff",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 1.60708,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      marker: "none",
      enableBackground: "accumulate"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      strokeWidth: 0.803539,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      strokeWidth: 1.60708,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2700.19 785.026a10.489 10.66 0 1 1-20.977 0 10.489 10.66 0 1 1 20.977 0z",
    transform: "matrix(-.17173 0 0 .18498 940.023 58.23)",
    style: {
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      fill: "#fff",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 1.60708,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      marker: "none",
      enableBackground: "accumulate"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 1.17646,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 1.17646,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-346.459 1090.707h16.902l2.2 3.807-2.2 3.806h-16.902l-2.706-3.806z",
    style: {
      fill: "#fed100",
      fillOpacity: 1,
      stroke: "none"
    },
    transform: "matrix(.23424 -.0137 .01271 .25232 499.568 -76.302)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-346.459 1090.707h16.902l2.2 3.807-2.2 3.806h-16.902l-2.706-3.806z",
    style: {
      display: "inline",
      fill: "none",
      stroke: "#000",
      strokeWidth: 1.17646,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(.23424 -.0137 .01271 .25232 499.568 -76.302)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      strokeWidth: 1.17646,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-346.459 1090.707h16.902l2.2 3.807-2.2 3.806h-16.902l-2.706-3.806z",
    style: {
      fill: "#f6e078",
      fillOpacity: 1,
      stroke: "none"
    },
    transform: "matrix(-.23424 -.0137 -.01271 .25232 399.68 -76.302)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-346.459 1090.707h16.902l2.2 3.807-2.2 3.806h-16.902l-2.706-3.806z",
    style: {
      display: "inline",
      fill: "#fed100",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 1.17646,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(-.23424 -.0137 -.01271 .25232 399.68 -76.302)"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      strokeWidth: 1.17646,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      strokeWidth: 1.17646,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M390.388 381.08s12.056-.885 33.298-2.084c21.241-1.2 44-1.83 55.608-1.83h35.388c11.245 0 34.538.63 55.609 1.83 21.07 1.199 33.055 2.204 33.055 2.204l7.388-33.005s-75.7-6.83-113.746-6.83c-38.045 0-113.745 6.83-113.745 6.83z",
    style: {
      fill: "#fed100",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "matrix(.23459 0 0 .25269 333.042 123.911)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.5 341.725a1029.03 1029.03 0 0 1 113.864 6.235l-6.928 33.312c-37.64-3.379-68.45-4.283-106.509-4.58m.504-34.967a1029.03 1029.03 0 0 0-113.863 6.235l6.928 33.312c37.64-3.379 68.45-4.283 106.51-4.58",
    style: {
      display: "inline",
      fill: "none",
      stroke: "#000",
      strokeWidth: 1.17646,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(.23459 0 0 .25269 333.042 123.911)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      strokeWidth: 1.33004,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-644.322 561.769-.031.03h-.032c-13.369 1.258-28.842 2.629-42.343 5.032-1.91 2.982-2.068 5.7 1.406 7.875 12.963-2.307 28.246-3.711 41.625-4.969 18.145-1.374 36.44-2.233 54.687-2.468h35c10.916 0 33.969.87 54.688 2.5 20.625 1.622 41.687 4.937 41.687 4.937 3.595-2.398 3.204-5.08 1.25-7.875 0 0-21.257-3.406-42.312-5.062-20.96-1.65-43.984-2.5-55.313-2.5h-35c-18.464.072-36.9 1.21-55.312 2.5z",
    style: {
      color: "#000",
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: "medium",
      lineHeight: "normal",
      fontFamily: "'Bitstream Vera Sans'",
      InkscapeFontSpecification: "'Bitstream Vera Sans'",
      textIndent: 0,
      textAlign: "start",
      textDecoration: "none",
      textDecorationLine: "none",
      letterSpacing: "normal",
      wordSpacing: "normal",
      textTransform: "none",
      writingMode: "lr-tb",
      direction: "ltr",
      textAnchor: "start",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      fill: "#fed100",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.33004,
      marker: "none",
      enableBackground: "accumulate"
    },
    transform: "matrix(.23718 0 0 .19554 585.173 100.616)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-644.322 561.769-.031.03h-.032c-13.369 1.258-28.842 2.629-42.343 5.032-1.91 2.982-2.068 5.7 1.406 7.875 12.963-2.307 28.246-3.711 41.625-4.969 18.145-1.374 36.44-2.233 54.687-2.468h35c10.916 0 33.969.87 54.688 2.5 20.625 1.622 41.687 4.937 41.687 4.937 3.595-2.398 3.204-5.08 1.25-7.875 0 0-21.257-3.406-42.312-5.062-20.96-1.65-43.984-2.5-55.313-2.5h-35c-18.464.072-36.9 1.21-55.312 2.5z",
    style: {
      color: "#000",
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: "medium",
      lineHeight: "normal",
      fontFamily: "'Bitstream Vera Sans'",
      InkscapeFontSpecification: "'Bitstream Vera Sans'",
      textIndent: 0,
      textAlign: "start",
      textDecoration: "none",
      textDecorationLine: "none",
      letterSpacing: "normal",
      wordSpacing: "normal",
      textTransform: "none",
      writingMode: "lr-tb",
      direction: "ltr",
      textAnchor: "start",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      fill: "none",
      stroke: "#000",
      strokeWidth: 1.33004,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1,
      marker: "none",
      enableBackground: "accumulate"
    },
    transform: "matrix(.23718 0 0 .19554 585.173 100.616)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      strokeWidth: 1.37932,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-644.322 561.769-.031.03h-.032c-13.369 1.258-28.842 2.629-42.343 5.032-1.91 2.982-2.068 5.7 1.406 7.875 12.963-2.307 28.246-3.711 41.625-4.969 18.145-1.374 36.44-2.233 54.687-2.468h35c10.916 0 33.969.87 54.688 2.5 20.625 1.622 41.687 4.937 41.687 4.937 3.595-2.398 3.204-5.08 1.25-7.875 0 0-21.257-3.406-42.312-5.062-20.96-1.65-43.984-2.5-55.313-2.5h-35c-18.464.072-36.9 1.21-55.312 2.5z",
    style: {
      color: "#000",
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: "medium",
      lineHeight: "normal",
      fontFamily: "'Bitstream Vera Sans'",
      InkscapeFontSpecification: "'Bitstream Vera Sans'",
      textIndent: 0,
      textAlign: "start",
      textDecoration: "none",
      textDecorationLine: "none",
      letterSpacing: "normal",
      wordSpacing: "normal",
      textTransform: "none",
      writingMode: "lr-tb",
      direction: "ltr",
      textAnchor: "start",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      fill: "#fed100",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.37932,
      marker: "none",
      enableBackground: "accumulate"
    },
    transform: "matrix(.22054 0 0 .19554 575.66 109.305)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-644.322 561.769-.031.03h-.032c-13.369 1.258-28.842 2.629-42.343 5.032-1.91 2.982-2.068 5.7 1.406 7.875 12.963-2.307 28.246-3.711 41.625-4.969 18.145-1.374 36.44-1.778 54.687-2.013h35c10.916 0 33.969.415 54.688 2.045 20.625 1.622 41.687 4.937 41.687 4.937 3.595-2.398 3.204-5.08 1.25-7.875 0 0-21.257-3.406-42.312-5.062-20.96-1.65-43.984-2.045-55.313-2.045h-35c-18.464.072-36.9.754-55.312 2.045z",
    style: {
      color: "#000",
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: "medium",
      lineHeight: "normal",
      fontFamily: "'Bitstream Vera Sans'",
      InkscapeFontSpecification: "'Bitstream Vera Sans'",
      textIndent: 0,
      textAlign: "start",
      textDecoration: "none",
      textDecorationLine: "none",
      letterSpacing: "normal",
      wordSpacing: "normal",
      textTransform: "none",
      writingMode: "lr-tb",
      direction: "ltr",
      textAnchor: "start",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      fill: "none",
      stroke: "#000",
      strokeWidth: 1.37932,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1,
      marker: "none",
      enableBackground: "accumulate"
    },
    transform: "matrix(.22054 0 0 .19554 575.66 109.305)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 1.17646,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 1.17646,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      strokeWidth: 2.66007,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    width: 89.493,
    height: 59.169,
    ry: 3.006,
    x: 2840.095,
    y: 823.565,
    style: {
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      fill: "none",
      stroke: "#000",
      strokeWidth: 2.66007,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      marker: "none",
      enableBackground: "accumulate"
    },
    transform: "matrix(.1186 0 0 .09777 107.505 131.637)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 2.66007,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    transform: "matrix(.1186 0 0 .09777 107.505 131.637)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 2.66007,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70.263,
    height: 43.637,
    ry: 5.177,
    x: 2849.709,
    y: 831.331,
    style: {
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      fill: "#012169",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#a0892c",
      strokeWidth: 2.66007,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      marker: "none",
      enableBackground: "accumulate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2918.46 873.455a5.16 5.16 0 0 1-3.665 1.513h-59.908a5.16 5.16 0 0 1-3.665-1.513 5.161 5.161 0 0 1-1.513-3.664v-33.283c0-1.434.578-2.728 1.513-3.664.936-.936 68.173 39.675 67.237 40.611z",
    style: {
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      fill: "#2b96f6",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#a0892c",
      strokeWidth: 2.66007,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      marker: "none",
      enableBackground: "accumulate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2918.46 873.455a5.16 5.16 0 0 1-3.665 1.513h-59.908a5.16 5.16 0 0 1-3.665-1.513 5.161 5.161 0 0 1-1.513-3.664v-33.283c0-1.434.578-2.728 1.513-3.664.476-.475 18.04 9.759 35.097 20.073 16.54 10.001 32.6 20.077 32.14 20.538z",
    style: {
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      fill: "#012169",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 2.66007,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      marker: "none",
      enableBackground: "accumulate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2918.46 832.844a5.161 5.161 0 0 1 1.512 3.664v33.283a5.161 5.161 0 0 1-1.513 3.664 5.16 5.16 0 0 1-3.664 1.513h-59.908a5.16 5.16 0 0 1-3.665-1.513c-.935-.936 66.301-41.546 67.237-40.61z",
    style: {
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      fill: "#012169",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 2.66007,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      marker: "none",
      enableBackground: "accumulate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2918.46 873.455a5.16 5.16 0 0 1-3.665 1.513h-59.908a5.16 5.16 0 0 1-3.665-1.513c-.474-.475 16.6-11.163 33.661-21.457 0 0 34.512 20.521 33.576 21.457z",
    style: {
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      fill: "#012169",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 2.66007,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      marker: "none",
      enableBackground: "accumulate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 70.263,
    height: 43.637,
    ry: 5.177,
    x: 2849.709,
    y: 831.331,
    style: {
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      fill: "none",
      stroke: "#000",
      strokeWidth: 2.66007,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      marker: "none",
      enableBackground: "accumulate"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    width: 39.367,
    height: 22.304,
    ry: 0,
    x: 2865.157,
    y: 841.292,
    style: {
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      fill: "#012169",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 2.66007,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      marker: "none",
      enableBackground: "accumulate"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 1.17646,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 1.17646,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.20308 -.0215 .0319 .19463 320.524 157.952)",
    style: {
      display: "inline",
      strokeWidth: 1.42758,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.829,
    height: 22.674,
    ry: 10.771,
    x: 494.629,
    y: 340.211,
    style: {
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      fill: "#fed100",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 1.42838,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      marker: "none",
      enableBackground: "accumulate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 29.954,
    height: 16.542,
    ry: 8.271,
    x: 497.566,
    y: 343.276,
    style: {
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      fill: "#306947",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1.42838,
      marker: "none",
      enableBackground: "accumulate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 29.954,
    height: 16.542,
    ry: 8.271,
    x: 497.566,
    y: 343.276,
    style: {
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      fill: "none",
      stroke: "#000",
      strokeWidth: 1.42838,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      marker: "none",
      enableBackground: "accumulate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      strokeWidth: 1.36121,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m626.165 310.883-23.7-12.77 23.7-12.082 2.882 13.146z",
    style: {
      display: "inline",
      fill: "#fed100",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 1.36121,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(-.19192 .03609 .03628 .22389 532.88 127.035)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m626.165 307.466-17.182-9.259 17.182-8.759 5.657 8.579z",
    style: {
      display: "inline",
      fill: "#c8102e",
      fillOpacity: 1,
      stroke: "none"
    },
    transform: "matrix(-.19192 .03609 .03628 .22389 532.88 127.035)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m626.165 307.466-17.182-9.259 22.66-.18z",
    style: {
      display: "inline",
      fill: "#c8102e",
      fillOpacity: 1,
      stroke: "none"
    },
    transform: "matrix(-.19192 .03609 .03628 .22389 532.88 127.035)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m452.404 250.56 22.954-.024",
    transform: "matrix(-.19192 .03609 .03628 .22389 504.564 143.337)",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1.36121,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m626.165 307.466-17.182-9.259 17.182-8.759 5.837 8.399z",
    style: {
      display: "inline",
      fill: "none",
      stroke: "#000",
      strokeWidth: 1.36121,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(-.19192 .03609 .03628 .22389 532.88 127.035)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 1.17646,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 1.30718,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 1.45242,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      strokeWidth: 3.2276,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2700.19 785.026a10.489 10.66 0 1 1-20.977 0 10.489 10.66 0 1 1 20.977 0z",
    transform: "matrix(.0855 0 0 .0921 211.768 141.247)",
    style: {
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      fill: "#fff",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.2276,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      marker: "none",
      enableBackground: "accumulate"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      strokeWidth: 1.45242,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      strokeWidth: 3.2276,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2700.19 785.026a10.489 10.66 0 1 1-20.977 0 10.489 10.66 0 1 1 20.977 0z",
    transform: "matrix(.0855 0 0 .0921 211.952 144.327)",
    style: {
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      fill: "#fff",
      stroke: "#000",
      strokeWidth: 3.2258,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      marker: "none",
      enableBackground: "accumulate"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      strokeWidth: 1.30718,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 1.45242,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      strokeWidth: 3.2276,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2700.19 785.026a10.489 10.66 0 1 1-20.977 0 10.489 10.66 0 1 1 20.977 0z",
    transform: "matrix(.0855 0 0 .0921 199.702 141.958)",
    style: {
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      fill: "#fff",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.2276,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      marker: "none",
      enableBackground: "accumulate"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      strokeWidth: 1.45242,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      strokeWidth: 3.2276,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2700.19 785.026a10.489 10.66 0 1 1-20.977 0 10.489 10.66 0 1 1 20.977 0z",
    transform: "matrix(.0855 0 0 .0921 199.886 145.038)",
    style: {
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      fill: "#fff",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.2276,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      marker: "none",
      enableBackground: "accumulate"
    }
  })))))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      strokeWidth: 1.17646,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-.20308 -.0215 -.0319 .19463 578.723 157.952)",
    style: {
      display: "inline",
      strokeWidth: 1.42758,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.829,
    height: 22.674,
    ry: 10.771,
    x: 494.629,
    y: 340.211,
    style: {
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      fill: "#fed100",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 1.42838,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      marker: "none",
      enableBackground: "accumulate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 29.954,
    height: 16.542,
    ry: 8.271,
    x: 497.566,
    y: 343.276,
    style: {
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      fill: "#306947",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1.42838,
      marker: "none",
      enableBackground: "accumulate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 29.954,
    height: 16.542,
    ry: 8.271,
    x: 497.566,
    y: 343.276,
    style: {
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      fill: "none",
      stroke: "#000",
      strokeWidth: 1.42838,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      marker: "none",
      enableBackground: "accumulate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      strokeWidth: 1.36121,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m626.165 310.883-23.7-12.77 23.7-12.082 2.882 13.146z",
    style: {
      display: "inline",
      fill: "#fed100",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 1.36121,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(.19192 .03609 -.03628 .22389 366.368 127.035)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m626.165 307.466-17.182-9.259 17.182-8.759 5.657 8.579z",
    style: {
      display: "inline",
      fill: "#c8102e",
      fillOpacity: 1,
      stroke: "none"
    },
    transform: "matrix(.19192 .03609 -.03628 .22389 366.368 127.035)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m626.165 307.466-17.182-9.259 22.66-.18z",
    style: {
      display: "inline",
      fill: "#c8102e",
      fillOpacity: 1,
      stroke: "none"
    },
    transform: "matrix(.19192 .03609 -.03628 .22389 366.368 127.035)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m452.404 250.56 22.954-.024",
    transform: "matrix(.19192 .03609 -.03628 .22389 394.683 143.337)",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1.36121,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m626.165 307.466-17.182-9.259 17.182-8.759 5.837 8.399z",
    style: {
      display: "inline",
      fill: "none",
      stroke: "#000",
      strokeWidth: 1.36121,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(.19192 .03609 -.03628 .22389 366.368 127.035)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 1.17646,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 1.30718,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 1.45242,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      strokeWidth: 3.2276,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2700.19 785.026a10.489 10.66 0 1 1-20.977 0 10.489 10.66 0 1 1 20.977 0z",
    transform: "matrix(-.0855 0 0 .0921 687.48 141.247)",
    style: {
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      fill: "#fff",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.2276,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      marker: "none",
      enableBackground: "accumulate"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      strokeWidth: 1.45242,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      strokeWidth: 3.2276,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2700.19 785.026a10.489 10.66 0 1 1-20.977 0 10.489 10.66 0 1 1 20.977 0z",
    transform: "matrix(-.0855 0 0 .0921 687.296 144.327)",
    style: {
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      fill: "#fff",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.2276,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      marker: "none",
      enableBackground: "accumulate"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      strokeWidth: 1.30718,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 1.45242,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      strokeWidth: 3.2276,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2700.19 785.026a10.489 10.66 0 1 1-20.977 0 10.489 10.66 0 1 1 20.977 0z",
    transform: "matrix(-.0855 0 0 .0921 699.545 141.958)",
    style: {
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      fill: "#fff",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.2276,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      marker: "none",
      enableBackground: "accumulate"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      strokeWidth: 1.45242,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      strokeWidth: 3.2276,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2700.19 785.026a10.489 10.66 0 1 1-20.977 0 10.489 10.66 0 1 1 20.977 0z",
    transform: "matrix(-.0855 0 0 .0921 699.362 145.038)",
    style: {
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      fill: "#fff",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 3.2276,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      marker: "none",
      enableBackground: "accumulate"
    }
  }))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIo);
export default __webpack_public_path__ + "static/media/io.b3bd4a167fac82cc8538ff9bd8a418d7.svg";
export { ForwardRef as ReactComponent };